// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type ProgramSwitcherSelectionType = 'NOT_SELECTED' | 'PROGRAM' | 'COURSERA' | 'DEGREE';

export interface ProgramSwitcherSelectionsV1 {
  id: string;
  userId: number;
  selectionType: ProgramSwitcherSelectionType;
  programId?: string | null;
  degreeId?: string | null;
}

export interface ProgramSwitcherSelection {
  selectionType: ProgramSwitcherSelectionType;
  programId?: string | null;
  degreeId?: string | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramSwitcherSelectionsV1Connection {
  elements: Array<ProgramSwitcherSelectionsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramSwitcherSelectionsV1GetQuery {
  ProgramSwitcherSelectionsV1: {
    get: ProgramSwitcherSelectionsV1Connection | null;
  } | null;
}

export interface ProgramSwitcherSelectionsV1GetQueryVariables {
  id: string;
  validateSelection?: string | null;
  includes?: string | null;
}

export interface ProgramSwitcherSelectionsV1MultiGetQuery {
  ProgramSwitcherSelectionsV1: {
    multiGet: ProgramSwitcherSelectionsV1Connection | null;
  } | null;
}

export interface ProgramSwitcherSelectionsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface ProgramSwitcherSelectionsV1UpdateMutation {
  ProgramSwitcherSelectionsV1: {
    update: ProgramSwitcherSelectionsV1Connection | null;
  } | null;
}

export interface ProgramSwitcherSelectionsV1UpdateMutationVariables {
  id: string;
  input: ProgramSwitcherSelection;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class ProgramSwitcherSelectionsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programSwitcherSelections.v1' as const;

  declare id: string;

  declare userId: number;

  declare selectionType: ProgramSwitcherSelectionType;

  declare programId?: string | null;

  declare degreeId?: string | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramSwitcherSelectionsV1>) {
    super(params);
  }
}
